import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setHandToolActiveReducer = (state: EditorState, { payload: active }: PayloadAction<boolean>) => {
  state.handToolActive = active;
};

export default setHandToolActiveReducer;
